import { ContactConfig } from '../../contact.types';

export default {
  headerText: `
  To start using PIV card, you must first log in at least one time using a CMS issued EUA username
  and password. If you are having trouble, please go to <a href="https://eua.cms.gov" target="_blank">eua.cms.gov</a> to reset your username and
  password. Please note that once logged in, you may need to re-request user roles when using EUA.
  For more information, please view the <a href="https://qnetconfluence.cms.gov/display/HS/HARP" target="_blank">HARP User Guide</strong>.`,
  links: [
    {
      label:
        'Visit Enterprise User Administration (EUA) to reset your username and password',
      link: 'https://eua.cms.gov/iam/im/pri/',
    },
  ],
  contactDetails: {
    hours: 'Available 24/7',
    days: 'Monday - Friday',
    email: 'ServiceCenterSOS@cms.hhs.gov',
    phone1: '1-866-288-8914',
    slack: '#help-service-center-sos',
  },
} as ContactConfig;
